// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"053272c4","962":"ed585b91"}[chunkId] + ".chunk.js";
};